


import {Component, Prop, Vue} from 'vue-property-decorator';
import PopupService from '@/services/popup.service';

@Component({})
export default class AppEnlargedImage extends Vue {

  @Prop({default: 'imagePreview'})
  public name!: string;

  private popupService: PopupService = PopupService.getInstance();

  public close(): void {
    this.popupService.close(this.name, null);
  }

  public isOpened(): boolean {
    return this.popupService.isOpened(this.name);
  }

  public params(): Params {
    return this.popupService.params(this.name) as Params;
  }
}

interface Params {
  imageSrc: string;
}
